<h2 *ifPermissions="['Engage Transfer']" class="section-header mat-headline">
  {{ "TransferReview.ConfirmTransfer" | translate }}
</h2>
<h2
  *ifPermissions="['Engage Support', 'Internal Admin']"
  class="section-header mat-headline"
>
  {{ "TransferReview.ConfirmGeneration" | translate }}
</h2>
<div class="details-section">
  <h3 *ifPermissions="['Engage Transfer']" class="details-header mat-title">
    {{ "TransferReview.TransferTypeReview" | translate }}
  </h3>
  <h3
    *ifPermissions="['Engage Support', 'Internal Admin']"
    class="details-header mat-title"
  >
    {{ "TransferReview.GenerateTypeReview" | translate }}
  </h3>
  <div class="details">
    <h3 class="mat-body-1">{{ form.value.accountType }}</h3>
  </div>
</div>
<div class="details-section">
  <h3 class="details-header mat-title">
    {{ "TransferReview.RecipientDetailsReview" | translate }}
  </h3>
  <div>
    <div
      class="details"
      *ngIf="form.value.accountType === 'ENGAGE&trade; Account'"
    >
      <div class="detail1">
        <p class="mat-body-1">
          {{ "TransferReview.RecipientSiteIDReview" | translate }}:
        </p>
        <p class="mat-body-1">{{ form.value.siteId }}</p>
      </div>
      <div class="detail1">
        <p class="mat-body-1">
          {{ "TransferReview.RecipientInfoReview" | translate }}:
        </p>
        <p class="mat-body-1">{{ siteIdDisplay }}</p>
      </div>
    </div>
    <div
      class="details"
      *ngIf="form.value.accountType === 'License Management Account'"
    >
      <div class="detail1">
        <p class="mat-body-1">
          {{ "TransferReview.RecipientEmailReview" | translate }}:
        </p>
        <p class="mat-body-1">{{ form.value.email }}</p>
      </div>
    </div>
  </div>
  <div class="details" *ngIf="form.value.accountType === 'Company Search'">
    <div class="detail1">
      <p class="mat-body-1">
        {{ "TransferReview.RecipientInfoReview" | translate }}:
      </p>
      <p class="mat-body-1">
        {{ form.value.accountId.businessId }}
        <br />
        Account # {{ form.value.accountId.accountNumber || "N/A" }}
      </p>
    </div>
  </div>
</div>

<div class="details-section">
  <h3 class="details-header mat-subheading-2">
    {{ "TransferReview.CreditDetailsReview" | translate }}
  </h3>
  <div class="details">
    <div>
      <p class="mat-body-1">
        {{ "TransferReview.CreditTypeReview" | translate }}:
      </p>
      <p class="mat-body-1">{{ productName }}</p>
    </div>
    <div>
      <p class="mat-body-1">{{ "TransferReview.AmountReview" | translate }}:</p>
      <p class="mat-body-1">{{ form.value.quantity }}</p>
    </div>
    <div *ifPermissions="['Engage Transfer']">
      <p class="mat-body-1">
        {{ "TransferReview.PONumberReview" | translate }}:
      </p>
      <p class="mat-body-1">{{ form.value.purchaseOrder }}</p>
    </div>
    <div>
      <p class="mat-body-1">{{ "TransferReview.NotesReview" | translate }}:</p>
      <p class="mat-body-1">
        {{ form.value.notes }}
      </p>
    </div>
  </div>
</div>

<div class="buttons-container">
  <div class="flex flex-space-between">
    <app-button
      buttonColor="accent"
      [buttonText]="'TransferReview.BackReview' | translate"
      buttonClass="buttonStyle buttonStyle-outlined"
      (click)="viewToggler.emit()"
    ></app-button>
    <app-button
      *ifPermissions="['Engage Transfer']"
      buttonColor="primary"
      [buttonText]="'TransferReview.CompleteTransferReview' | translate"
      buttonClass="buttonStyle buttonStyle-default"
      (click)="submitTransfer.emit()"
    ></app-button>
    <app-button
      *ifPermissions="['Engage Support', 'Internal Admin']"
      buttonColor="primary"
      [buttonText]="'TransferReview.CompleteGenerationReview' | translate"
      buttonClass="buttonStyle buttonStyle-default"
      (click)="submitSupportTransfer.emit()"
    ></app-button>
  </div>
</div>

<app-credits-transfer-success
  (navigateToInventory)="handleNavigateToInventory()"
  (navigateToHistory)="handleNavigateToHistory()"
  (navigateToTransfer)="handleNavigateToTransfer()"
  *ngIf="transferMessage == 'success'"
></app-credits-transfer-success>
<app-credits-transfer-failure
  [requestType]="'transfer'"
  (tryAgainHandler)="tryAgainHandler()"
  (togglePopUp)="closeTransferPopup()"
  *ngIf="transferMessage == 'failure'"
></app-credits-transfer-failure>
